module.exports = __webpack_public_path__ + "img/9.e9d1e7ff.jpg";